import "./SolarBatterySystemsGenerators.module.css";
import MainHeader from "@/reusable_sections/Header";
import HeroCallToAction from "./sections/HeroCallToAction";
import OurConsultingServicesForCreteco from "./sections/OurConsultingServicesForCreteco";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import GetInTouch from "./sections/GetInTouch";
import DealershipHubFooter from "@/reusable_sections/Footer";
export default function SolarBatterySystemsGeneratorsPage() {
  return <div>
      <MainHeader />
      <HeroCallToAction />
      <OurConsultingServicesForCreteco />
      <FrequentlyAskedQuestions />
      <GetInTouch />
      <DealershipHubFooter />
    </div>;
}